import sa from 'sa-sdk-javascript'

export function saPaySource (name) {
  sa.track('Hpay_page_viewed', {
    source: name ? 'top_up' : 'place_order'
  })
}

export function saPayMethods (name) {
  sa.track('Hpay_online_method_selected', {
    online_payment_method: name
  })
}

export function saRechargeClick () {
  sa.track('Hpay_topup_wallet_clicked', {
    button_type: 'top_up_wallet'
  })
}

export function saProceedPaymentType (name) {
  sa.track('Hpay_Proceed_Now_clicked', {
    source: name
  })
}

export function saPayButtonClick (name) {
  sa.track('Hpay_Pay_clicked', {
    source: name
  })
}

export function saCreditCardPageViewed (name) {
  sa.track('credit_card_page_viewed', {
    credit_card_page: 'credit_card_page'
  })
}

export function saCreditCardPayClick (name) {
  sa.track('credit_card_Pay_clicked', {
    online_payment_method: name
  })
}

export function saCreditOriginPayType (name) {
  sa.track('credit_card_updated', {
    original_payment_method: name
  })
}

export function saCreditNewPayType (name) {
  sa.track('credit_card_updated', {
    new_payment_method: name
  })
}

export function saCreditCarRemove () {
  sa.track('saved_credit_card_removed', {
    button_type: 'remove'
  })
}

export function saCreditCardSave (name) {
  sa.track('new_credit_card_added', {
    is_saved_for_next: name
  })
}
